import { routePath } from "../../routes/routePath";

export const pageInfoAccess = {
  root: [
    { name: "ホームページ", url: routePath.homepage },
    { name: "交通のご案内", url: routePath.access },
  ],
  pageHeader: "交通のご案内",
};
